import { render, staticRenderFns } from "./AssistantNotesWidget.vue?vue&type=template&id=78c557f9&scoped=true"
import script from "./AssistantNotesWidget.vue?vue&type=script&lang=js"
export * from "./AssistantNotesWidget.vue?vue&type=script&lang=js"
import style0 from "./AssistantNotesWidget.vue?vue&type=style&index=0&id=78c557f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c557f9",
  null
  
)

export default component.exports